import { aesPaths } from '@vnetwork/margarita-aes/paths';
import { certinventPaths } from '@vnetwork/margarita-certinvent/paths';
import { computePaths } from '@vnetwork/margarita-compute/paths';
import { databasePaths } from '@vnetwork/margarita-database/paths';
import { eaglePaths } from '@vnetwork/margarita-eagle/paths';
import { fastchannelPaths } from '@vnetwork/margarita-fastchannel/paths';
import { healthcheckPaths } from '@vnetwork/margarita-healthcheck/paths';
import { hostingPaths } from '@vnetwork/margarita-hosting/paths';
import { instancesV3Paths } from '@vnetwork/margarita-instancesv3/paths';
import { kubernetesPaths } from '@vnetwork/margarita-kubernetes/paths';
import { livePaths } from '@vnetwork/margarita-live/paths';
import { mailPaths } from '@vnetwork/margarita-mail/paths';
import { mediaV2Paths } from '@vnetwork/margarita-mediav2/paths';
import { organizationsPaths } from '@vnetwork/margarita-organizations/paths';
import { ossPaths } from '@vnetwork/margarita-oss/paths';
import { privateZonesPaths } from '@vnetwork/margarita-privatezones/paths';
import { ravenPaths } from '@vnetwork/margarita-raven/paths';
import { usagePaths } from '@vnetwork/margarita-usage/paths';
import { vodPaths } from '@vnetwork/margarita-vod/paths';
import { waapPaths } from '@vnetwork/margarita-waap/paths';
import { wafPaths } from '@vnetwork/margarita-waf/paths';

/**
 * The one `paths` object: every module's `paths.ts`, merged here and nowhere else. A module
 * declares the routes it owns (`as const`, so each value stays a string literal type); this
 * file only lists them. Consumers do not import this file: they take `paths` from `@/lib/paths`
 * (the one place `check:coupling` lets a shared layer reach the composition root).
 *
 * Keyed by module, camelCase, not flattened: two modules cannot collide on `base`, and
 * `paths.compute.instance(...)` reads as "Compute owns this". To add a module: export
 * `<module>Paths` from its `paths.ts` and add one line here.
 */
export const paths = {
  aes: aesPaths,
  certinvent: certinventPaths,
  compute: computePaths,
  database: databasePaths,
  eagle: eaglePaths,
  fastchannel: fastchannelPaths,
  healthcheck: healthcheckPaths,
  hosting: hostingPaths,
  instancesV3: instancesV3Paths,
  kubernetes: kubernetesPaths,
  live: livePaths,
  mail: mailPaths,
  mediaV2: mediaV2Paths,
  organizations: organizationsPaths,
  oss: ossPaths,
  privateZones: privateZonesPaths,
  raven: ravenPaths,
  usage: usagePaths,
  vod: vodPaths,
  waap: waapPaths,
  waf: wafPaths,
} as const;
